/**
 * Story-world engine registry.
 *
 * Engines here are imported and spread into miniAppRegistry (src/miniapps/index.js)
 * so the guided lesson player can resolve them by key, exactly like educational engines.
 *
 * Key convention:  engine_<name>
 * activityType:    <name>  (mapped in guidedLessonRegistry.guidedActivityTypeToAppKey)
 */
import StoryChoiceEngine from './StoryChoiceEngine';

export const storyEngineRegistry = {
  engine_story_choice: StoryChoiceEngine,
};
